<template>
<div>
    <div class="container">
        <div class="space-100"></div>
        <div class="row">
            <div class="col-sm-9">
                <h2>Comercios afiliados</h2>
            </div>
            <div class="col-sm-2 text-right back-button">
                <router-link class="nav-link"  to="/PerfilUsuario">
                    <a class="text-color" href=""><img src="../assets/assets_loyalty/flecha-izquierda.png"> Regresar</a>
                </router-link>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>

            <div class="col-sm-2 text-center borders-defult">
                <img class="comer-img" src="../assets/assets_loyalty/assets-14.png" alt="">
                <p class="margin-defult">Saldo disponible</p>
                <h4 class="margin-defult">$20.00</h4>
                <p class="sucursal-title"><strong>9 sucursales </strong></p>
                <a class="text-color-blue" href=""><strong>Ver detalles</strong></a>
            </div>
        </div>
        <div class="space-50"></div>
    </div>
</div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data(){
    return {
    }
  }
}
</script>
<style>
.margin-defult{
    margin: 0px;
}
.text-color-blue{
    color: #00bbff;
}
.comer-img{
    width:65%;
    margin: 10px;
}
.borders-defult{
    margin: 0%;
    padding: 5px;
    margin: 8px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.sucursal-title{
    color:orange;
}
.back-button{
    margin-top: 20px;
}
</style>
